import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import './CollectionListingPage.css';
import '@shopify/polaris/dist/styles.css';
import {AppProvider, Page} from '@shopify/polaris';
import CollectionListing from '../components/CollectionListing';
import { getFetch } from '../helpers/request';

interface CollectionListingPageProps {

}

interface CollectionListingPageState {
  shopOrigin: string
}

class CollectionListingPage extends Component <CollectionListingPageProps, CollectionListingPageState> {

  static contextTypes = {
		polaris: PropTypes.object
  };

  constructor(props: CollectionListingPageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => {
      if (!res.ok) throw new Error('Not authenticated');
      return res.json();
    }).then((data) => {
      this.setState({ shopOrigin: data.shop_origin });
    }).catch(err => {
      window.location.assign('/login');
    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Page>
          <CollectionListing></CollectionListing>
        </Page>
      </AppProvider>
    );
  }
}

export default CollectionListingPage;
